import { makeAutoObservable } from 'mobx'
import { Status } from 'shared/ui'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import {
  EnumMenuAIAutomationItemsKey,
  menuItems,
} from 'widgets/Menu/ui/MenuAIAutomation/constants/menuItems'
import { MenuStore } from 'widgets/Menu/store/menuStore'
import { getStateAccessAIAutomation } from 'widgets/Menu/ui/MenuAIAutomation/lib/getPathAIAutomation'

export class MenuAIAutomationStore {
  private readonly _menuStore: MenuStore

  constructor(key: string, private _entities: IEntitiesStore) {
    makeAutoObservable(this)

    this._menuStore = new MenuStore(
      {
        key: key,
      },
      this._entities
    )
  }

  hideStateAccess = (key: EnumMenuAIAutomationItemsKey) => {
    if (this._entities.subscriptionStore.isAgencyWithoutSubscription) return true

    switch (key) {
      case 'chatbot':
        return !getStateAccessAIAutomation(key, this._entities)
      case 'knowledge_base':
        return !getStateAccessAIAutomation(key, this._entities)
      case 'workflows':
        return !getStateAccessAIAutomation(key, this._entities)
      case 'keywords':
        return !getStateAccessAIAutomation(key, this._entities)
      case 'hubspot_workflows':
        return !getStateAccessAIAutomation(key, this._entities)
      case 'click_to_text':
        return !getStateAccessAIAutomation(key, this._entities)
      default:
        return false
    }
  }

  disabledStateAccess = (key: EnumMenuAIAutomationItemsKey) => {
    switch (key) {
      case 'campaigns':
        return !getStateAccessAIAutomation(key, this._entities)
      default:
        return false
    }
  }

  get menuStore() {
    return this._menuStore
  }

  get menuItems() {
    return menuItems
      .map((item) => {
        if (item.type === 'nav') {
          const disabled = this.disabledStateAccess(item.key)

          item.disabled = disabled
          item.rightContent = disabled ? (
            <Status title={'Coming soon'} intent={'white_label'} emphasis={'high'} size={'label'} />
          ) : (
            item.rightContent
          )

          if (item.key === EnumMenuAIAutomationItemsKey.click_to_text && !disabled) {
            item.onClick = () => {
              this._entities.eventLogStore.logEvent(
                'Click to Text Used',
                {
                  event_id: 'click_to_text_used',
                  action: 'Menu item clicked',
                  agencyId: this._entities.organizationStore.agency_id,
                },
                { groupId: this._entities.organizationStore.id }
              )
            }
          }
        }

        if (item.type === 'sub') {
          item.items = item.items.map((child) => {
            if (child.type === 'nav' && child.key === EnumMenuAIAutomationItemsKey.click_to_text) {
              child.onClick = () => {
                this._entities.eventLogStore.logEvent(
                  'Click to Text Used',
                  {
                    event_id: 'click_to_text_used',
                    action: 'Menu item clicked',
                    agencyId: this._entities.organizationStore.agency_id,
                  },
                  { groupId: this._entities.organizationStore.id }
                )
              }
            }
            return child
          })
        }

        return item
      })
      .filter((item) => {
        if (item.type === 'sub') {
          item.items = item.items.filter((child) => {
            return !this.hideStateAccess(child.key)
          })

          return Boolean(item.items.length)
        }

        return !this.hideStateAccess(item.key)
      })
  }
}
